import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { BillAccountsService } from '@amfam/billing/billaccount/data-access/lib/services/bill-accounts.service';
import { LoadingSpinnerService } from '@amfam/ui-kit/lib/loading-spinner/services/loading-spinner.service';

import {
  CanRegisterAction,
  CanRegisterFailAction,
  CanRegisterSuccessAction
} from './bill-account-can-register.actions';

export const canRegister = createEffect(
  (
    actions$ = inject(Actions),
    billingService = inject(BillAccountsService),
    spinner = inject(LoadingSpinnerService)
  ) => {
    return actions$.pipe(
      ofType(CanRegisterAction),
      map(action => action.payload),
      switchMap(payload => {
        spinner.start({ blockActions: true });
        const canRegister$ = billingService.canRegisterExp(
          payload.billAccountNumber,
          payload.policyNumber
        );
        return canRegister$.pipe(
          map(canRegisterReponse => {
            spinner.stop();
            return CanRegisterSuccessAction(canRegisterReponse);
          }),
          catchError(error => {
            spinner.stop();
            return of(CanRegisterFailAction(error));
          })
        );
      })
    );
  },
  { functional: true }
);
